import SponsorListComponent from '../../../components/Sponsors/SponsorsList/SponsorListComponent';
import { PageHeader } from '../../../commons/component/PageHeader/PageHeader';
// If the actual file is named SponsorProfitChartComponent.tsx, update the import as follows:
import SponsorProfitChartComponent from '../../../components/Sponsors/SponsorProfitChart/SponsorProfitChar.Component';
// Or, if the file is named SponsorProfitChartComponent.js:
//// import SponsorProfitChartComponent from '../../../components/Sponsors/SponsorProfitChart/SponsorProfitChartComponent.js';
////i18Next
import { useTranslation } from 'react-i18next';

export const SponsorsListPage = () => {
  
  //useTranslation
  const [t] = useTranslation();

  return (
    <>
      <PageHeader title={t('sponsorsListPage.sponsorsListTitle')} />
      <div className="Section">
        {process.env.REACT_APP_PREVIEW_FEATURES === 'true' && <SponsorProfitChartComponent />}
        <SponsorListComponent />
      </div>
    </>
  );
};
